import { render, staticRenderFns } from "./PreviewMediaModal.vue?vue&type=template&id=3dd60c7b&scoped=true&"
import script from "./PreviewMediaModal.vue?vue&type=script&lang=js&"
export * from "./PreviewMediaModal.vue?vue&type=script&lang=js&"
import style0 from "./PreviewMediaModal.vue?vue&type=style&index=0&id=3dd60c7b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd60c7b",
  null
  
)

export default component.exports